import { IRowColumnEditor } from '@modules/Edo/types';
import { Form, InputNumber } from 'antd';
import { useEffect, useState } from 'react';
import { IUser } from './FieldUser';
import { useSelector } from 'react-redux';

interface IAdminDay {
  settings: IRowColumnEditor;
  name: number;
  onChangeByTd: any;
  isAdmin: any;
  isDisabledStatus: any;
}

function AdminDay(props: IAdminDay) {
  const adminDaysCount: number = useSelector(
    (state: any) => state.count_admin_days
  );

  const [user, setUser] = useState<IUser | null>(null);

  const { settings, name, onChangeByTd, isAdmin, isDisabledStatus } = props;

  const form = Form.useFormInstance();

  const isRowColumnEditor = typeof name === 'number';
  const propertyValue = Form.useWatch(['row_column_editor', name], form);

  useEffect(() => {
    if (propertyValue) {
      const formValues = Object.values(propertyValue);

      formValues.map((element: any) => {
        if (element.type == 'DEPTEMPL') {
          setUser(element);
        }
      });
    }
  }, [propertyValue]);

  useEffect(() => {
    if (user) {
      if (isRowColumnEditor) {
        const { row_column_editor } = form.getFieldsValue();

        // Check if user.adminDay is a number
        if (typeof user?.adminDay === 'number') {
          // Ensure that row_column_editor[name] exists
          if (
            row_column_editor[name] &&
            row_column_editor[name][`id-${settings?.id}`]
          ) {
            Object.assign(row_column_editor[name][`id-${settings?.id}`], {
              char_value: user.adminDay,
            });
          } else {
            // Handle case where row_column_editor[name] or row_column_editor[name][`id-${settings?.id}`] is undefined
            console.warn('Invalid row_column_editor structure');
          }
        }

        form.setFieldsValue({ row_column_editor });
      }
    }
  }, [user]);

  switch (settings.field_name) {
    case 'Доступное кол-во дней':
      return (
        <Form.Item
          label={settings.field_name}
          rules={[{ required: settings.required }]}
        >
          <InputNumber
            value={adminDaysCount}
            disabled={true}
            style={{ width: '100%' }}
            type="number"
          />
        </Form.Item>
      );
    default:
      <Form.Item
        label={settings.field_name}
        name={[name, `id-${settings.id}`, 'char_value']}
        rules={[{ required: settings.required }]}
      >
        <InputNumber
          onChange={
            isAdmin && isDisabledStatus && onChangeByTd(settings.id, name)
          }
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace(/\,/g, '.')
          }
          parser={(x) =>
            parseFloat(`${x}`.replace(/\s/g, '').replace(/\,/g, '.'))
          }
          disabled={true}
          style={{ width: '100%' }}
          type="number"
        />
      </Form.Item>;
  };
  return <></>;
}

export default AdminDay;
